const getOnlineVideosPayload = (onlineVideos) => {
  return (
    onlineVideos?.map((v) => ({
      originalName: v.originalName,
      caption: v.caption,
      type: 'online',
      provider: v.provider,
      url: v.url
    })) ?? []
  )
}

const getImagesPayload = (customMessageEntity, images) => {
  const imagesPayload = customMessageEntity.images
    ? images.filter(
        (i) =>
          !customMessageEntity.images.some((x) => {
            return x.fileName === i.fileName
          })
      )
    : images

  return imagesPayload?.map((image) => ({
    originalName: image.originalName,
    caption: image.caption,
    type: image.type,
    fileSize: image.fileSize,
    binary: image.file
  }))
}

const getVideosPayload = (customMessageEntity, videos) => {
  return (
    videos
      ?.filter(
        (x) =>
          !customMessageEntity?.videos?.some((v) => {
            return x.FileName === v.FileName
          })
      )
      .map((v) => ({
        originalName: v.FileName,
        type: 'video',
        fileSize: v.fileSize,
        caption: v.caption,
        secondsDuration: v.secondsDuration,
        binary: v.binary
      })) ?? []
  )
}

const setCustomSectionEncodingPayload = (
  img,
  number_video,
  online,
  type,
  customMessageEntity,
  deletedFiles,
  fireDepartment,
  images,
  iarMember,
  tempUpdatedFiles,
  bodyText,
  order
) => {
  let deletedSeconds = 0
  const deletedFilesMap = new Map()
  deletedFiles.forEach((x) => deletedFilesMap.set(x, x))
  customMessageEntity.videos.forEach((vid) => {
    if (deletedFilesMap.get(vid.fileName)) {
      deletedSeconds += vid.secondsDuration
    }
  })
  const data = {
    title: customMessageEntity.title,
    richText: bodyText,
    videosNumber: number_video,
    images: img,
    onlineVideos: online,
    type: type,
    contentId: customMessageEntity._id ? customMessageEntity._id : '',
    positionFiles:
      customMessageEntity && customMessageEntity.positionFiles
        ? parseInt(customMessageEntity.positionFiles)
        : 0,
    identifier: fireDepartment.identifier,
    fireDepartmentId: fireDepartment.fireDepartmentId,
    socketChannels: [
      `${fireDepartment.fireDepartmentId.toString()}_custom_section`,
      `${fireDepartment.fireDepartmentId.toString()}_inner_custom_section`
    ],
    deletedFiles,
    updatedFiles: tempUpdatedFiles,
    deletedSeconds,
    memberId: iarMember.memberId,
    sendPushNotifications: customMessageEntity.sendPushNotification,
    sectionActive: customMessageEntity.sectionActive,
    order: order
  }

  if (customMessageEntity._id) {
    data.socketChannels.push(
      `${fireDepartment.fireDepartmentId.toString()}_${customMessageEntity._id}_custom_section`
    )
  } else {
    data.socketChannels.push(
      `${fireDepartment.fireDepartmentId.toString()}_${order}_custom_section`
    )
  }

  return data
}

export {
  getOnlineVideosPayload,
  getImagesPayload,
  getVideosPayload,
  setCustomSectionEncodingPayload
}
